<template>
  <div class="nw-header">
    <span class="navMenu" @click="handleNavMenu()">
      <i :class="isCollapse?'el-icon-s-fold':'el-icon-s-unfold'"></i>
    </span>
    <span class="logo" :class="groupId == 90003 ? 'top1' : 'top12'" @click="toSystem">
      <!-- <img src="/static/images/svolt/nanwang/logo.png" /> -->
      <img :class="groupId == 90003 ? 'height56' : 'height36'" :src="groupInfo.imageUrl" />
    </span>
    <!-- <span class="home" @click="toHome">
    <svg class="iconx" aria-hidden="true">
      <use xlink:href="#icon-shouye"></use>
    </svg>
  </span> -->
    <span class="title">
      {{groupInfo.showName}}
    </span>
    <!-- <span class="button-list-left">
    <Button class="btnx" :ac="active=='projectHome'?true:false" @click.native="setActive(projectMenuData[0])"></Button>
    <Button v-if="activeModuleIds.indexOf(183)!=-1" class="btnx" :ac="active=='wiringDiagram'?true:false" name="接线图" @click.native="setActive(projectMenuData[1])"></Button>
    <Button v-if="activeModuleIds.indexOf(30147)!=-1" class="btnx" :ac="active=='historyData'?true:false" name="历史数据" @click.native="setActive(projectMenuData[5])"></Button>
  </span> -->
    <div class="wrap">
      <span class="txt">{{title}}</span>
      <el-dropdown :hide-on-click="true" trigger="hover" @command="selectProject">
        <span class="el-dropdown-link">
          <i class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown"
          style="max-height: 200px !important; overflow: auto !important;top: 80px !important;">
          <el-dropdown-item :command="item" :disabled="item.isShow==0" v-for="(item, index) in projectoptions"
            :key="index">{{item.projectName}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- <span class="button-list-right">
    <div v-if="isArrow" :class="currentClickNumber > 0 ? 'arrow' : 'arrow arrowOpacity'" @click="fnPrev()">
      <i class="el-icon-d-arrow-left"></i>
    </div>
    <div class="fixedBox" :ref="`fixedBox`">
      <div class="centerScroll" ref="centerScroll" :style="`width: ${signleWidth * 10}px;transform: translate(${scrollResultWidth}px, 0);transition: 1s;`">
        <Button class="btnx" :ac="active=='projectHome'?true:false" dir="2" @click.native="setActive(projectMenuData[0])"></Button>
        <Button v-if="activeModuleIds.indexOf(183)!=-1" class="btnx" :ac="active=='wiringDiagram'?true:false" dir="2" name="接线图" @click.native="setActive(projectMenuData[1])"></Button>
        <Button v-if="activeModuleIds.indexOf(30147)!=-1" class="btnx" :ac="active=='historyData'?true:false" dir="2" name="历史数据" @click.native="setActive(projectMenuData[5])"></Button>
        <Button v-if="activeModuleIds.indexOf(186)!=-1" class="btnx" :ac="active=='incomeAssessment'?true:false" dir="2" name="收益评估" @click.native="setActive(projectMenuData[3])" style="margin-left: 8px;"></Button>
        <Button v-if="activeModuleIds.indexOf(184)!=-1" class="btnx" :ac="active=='intelligentEarlyWarning'?true:false" dir="2" name="智能预警" @click.native="setActive(projectMenuData[2])"></Button>
        <Button v-if="activeModuleIds.indexOf(189)!=-1" class="btnx" :ac="active=='downloadData'?true:false" dir="2" name="下载数据" @click.native="setActive(projectMenuData[6])"></Button>
        <Button v-if="activeModuleIds.indexOf(188)!=-1" class="btnx" :ac="active=='electricEnergyAnalysis'?true:false" dir="2" name="电能分析" @click.native="setActive(projectMenuData[7])"></Button>
        <Button v-if="activeModuleIds.indexOf(30256)!=-1" class="btnx" :ac="active=='cellMonitoring'?true:false" dir="2" name="电芯监控" @click.native="setActive(projectMenuData[8])"></Button>
        <Button v-if="activeModuleIds.indexOf(30265)!=-1" class="btnx" :ac="active=='meterMonitoring'?true:false" dir="2" name="电表监控" @click.native="setActive(projectMenuData[9])"></Button>
      </div>
    </div>
    <div v-if="isArrow" :class="noScrollRight ? 'arrow' : 'arrow arrowOpacity'" @click="fnNext(activeName)">
      <i class="el-icon-d-arrow-right"></i>
    </div>
  </span> -->
    <span class="exit">
      <el-popover placement="bottom-end" trigger="hover" popper-class="w-project-open-menu">
        <div class="w-project-menu-list">
          <ul class="position_relative">
            <li class="cursor_pointer">{{ username }}</li>
            <li class="cursor_pointer" @click="openUpdatePassword">修改密码</li>
            <li class="cursor_pointer" @click="quitLogin">退出</li>
          </ul>
        </div>
        <div slot="reference">
          <img src="/static/images/svolt/nanwang/exit.png" alt="">
        </div>
      </el-popover>
    </span>
    <div v-if="activeModuleIds.indexOf(30254)!=-1" class="btnx header-icon">
      <router-link :to="{ path: '/svolt/newsCenter',query:{projectId:projectId} }">
        <!-- <el-badge :value="2" class="item" type="warning"> -->
        <img src="/static/images/svolt/nanwang/news.png" />
        <!-- </el-badge> -->
      </router-link>
    </div>
    <span class="homePage" @click="toHome">
      <img src="/static/images/svolt/nanwang/homePage.png" />
    </span>
    <!-- <span class="ext-menu">
    <i class="el-icon-menu" @click="openExtMenu" />
  </span> -->
    <UpdatePassword :show="dlgshow" @close="closeDlg" ref="up"></UpdatePassword>
  </div>
</template>

<script>
  import {
    removeToken,
    getInfo
  } from '@/utils/auth';
  import USERAPI from '@/api/user';
  import WDAPI from '@/api/svolt/wiring-diagram';
  import Button from './button';
  import UpdatePassword from './updatePassword'
  export default {
    components: {
      Button,
      UpdatePassword
    },
    props: {
      active: {
        type: String
      }
    },
    data() {
      return {
        dlgshow: false,
        title: '',
        projectId: '',
        groupInfo: {},
        userInfo: {},
        authority: [], //权限
        groupId: '',
        username: '',
        projectoptions: [],
        /*
        接线图-190
        智能预警-184
        收益评估-186
        能耗分析-185
        历史数据-30147
        下载数据-189
        电能分析-188
        */
        projectMenuData: [{
            id: 'projectHome',
            resourceId: 0,
            srca: '/static/images/svolt/project-home-icon.png',
            srcb: '/static/images/svolt/project-home-icon-active.png',
            title: '首页'
          },
          {
            id: 'wiringDiagram',
            resourceId: 183,
            srca: '/static/images/svolt/wiring-diagram-icon.png',
            srcb: '/static/images/svolt/wiring-diagram-icon-active.png',
            title: '项目接线图'
          },
          {
            id: 'intelligentEarlyWarning',
            resourceId: 184,
            srca: '/static/images/svolt/intelligent-early-warning-icon.png',
            srcb: '/static/images/svolt/intelligent-early-warning-icon-active.png',
            title: '智能预警'
          },
          {
            id: 'incomeAssessment',
            resourceId: 186,
            srca: '/static/images/svolt/income-assessment-icon.png',
            srcb: '/static/images/svolt/income-assessment-icon-active.png',
            title: '收益评估'
          },
          {
            id: 'energyAnalysis',
            resourceId: 185,
            srca: '/static/images/svolt/energy-analysis-icon.png',
            srcb: '/static/images/svolt/energy-analysis-icon-active.png',
            title: '能耗分析'
          },
          // {id:'communicationDiagram',srca:'/static/images/svolt/communication-diagram-icon.png',srcb:'/static/images/svolt/communication-diagram-icon-active.png',title:'项目通讯图'},
          // {id:'controlStrategy',srca:'/static/images/svolt/control-strategy-icon.png',srcb:'/static/images/svolt/control-strategy-icon-active.png',title:'控制策略'},
          {
            id: 'historyData',
            resourceId: 30147,
            srca: '/static/images/svolt/history-data-icon.png',
            srcb: '/static/images/svolt/history-data-icon-active.png',
            title: '历史数据'
          },
          {
            id: 'downloadData',
            resourceId: 189,
            srca: '/static/images/svolt/download-data-icon.png',
            srcb: '/static/images/svolt/download-data-icon-active.png',
            title: '下载数据'
          },
          {
            id: 'electricEnergyAnalysis',
            resourceId: 188,
            srca: '/static/images/svolt/electric-energy-analysis-icon.png',
            srcb: '/static/images/svolt/electric-energy-analysis-icon-active.png',
            title: '电能分析'
          },
          {
            id: 'cellMonitoring',
            resourceId: 30256,
            srca: '/static/images/svolt/cell-data-icon.png',
            srcb: '/static/images/svolt/cell-data-icon-active.png',
            title: '电芯监控'
          },
          {
            id: 'meterMonitoring',
            resourceId: 30265,
            srca: '/static/images/svolt/meter-data-icon.png',
            srcb: '/static/images/svolt/meter-data-icon-active.png',
            title: '电表监控'
          },
          {
            id: 'newsCenter',
            resourceId: 30254,
            srca: '',
            srcb: '',
            title: '消息中心'
          },
          {
            id: 'typicalDaily',
            resourceId: 30254,
            srca: '',
            srcb: '',
            title: '典型日报'
          },
          {
            id: 'downloadList',
            resourceId: 30254,
            srca: '',
            srcb: '',
            title: '下载列表'
          },
        ],
        projectMenuDateAuth: [],
        currentProgressId: '',
        scrollResultWidth: 0, //transform滚动的距离
        signleWidth: 85, //单个流程的宽度
        activeName: 0,
        currentClickNumber: 0,
        noScrollRight: true,
        activeModuleIds: [],
        isArrow: false,
        platformResources: [],
        isCollapse: false
      };
    },
    inject: ['reload'],
    methods: {
      closeDlg(f) {
        this.dlgshow = false
        this.$refs['up'].clear()
        if (f == true) {
          this.quitLogin()
        }
      },
      openUpdatePassword() {
        this.dlgshow = true
      },
      handleNavMenu() {
        this.isCollapse = !this.isCollapse;
        this.$emit("setCollapse", this.isCollapse);
      },
      openExtMenu() {
        this.$emit("onExtMenu")
      },
      //获取项目列表
      async searchProjects() {
        let res = await WDAPI.searchProjects({
          groupId: this.groupId
        });
        if (res.data.code == 200) {
          this.projectoptions = res.data.data;
          this.projectoptions.forEach(item => {
            if (item.projectId == this.$route.query.projectId) {
              this.title = item.projectName;
            }
          });
        }
      },
      //切换菜单
      setActive(item) {
        this.$emit('setMenu', item.id, item.resourceId);
      },
      //项目首页
      toProjectHome() {
        this.$router.push({
          path: '/svolt/project',
          query: {
            projectId: this.projectId
          }
        });
      },
      //退出登录
      quitLogin() {
        //清除安全码
        USERAPI.clearUserControlPassword()
        USERAPI.logout().then(res => {
          removeToken();
          this.$router.push({
            path: '/login'
          });
        });
      },
      //切换项目
      selectProject(item) {
        if (item && this.$route.query.appid != "wiringDiagram" && !this.$route.query.buttonName && !this.$route.query
          .equipId) {
          this.projectId = item.projectId;
          this.toProjectHome();
        }
        let path = this.$route.path;
        delete(this.$route.query.tab);
        let query = {};
        let location = {};
        if (this.$route.query.buttonName && this.$route.query.equipId) {
          query = {
            appid: "wiringDiagram",
            projectId: item.projectId
          };
          location = {
            path: "/svolt/project",
            query: query
          };
        } else {
          query = {
            ...this.$route.query,
            ...{
              projectId: item.projectId
            }
          };
          location = {
            path: path,
            query: query
          };
        }
        this.toProject(item.projectId, 2, location);
      },
      //调用用户资源权限跳转项目页面
      toProject(projectId, systemId, location) {
        let params = {
          projectId: projectId,
          resourceId: systemId
        };
        USERAPI.searchUserResources(params).then(res => {
          if (res.data.code == 200 && !res.data.errors) {
            //保存权限模块
            localStorage.removeItem('ActiveProjectModule');
            let activeModule = {
              resourceIds: [],
              item: []
            };
            let data = res.data.data;
            data.forEach(item => {
              activeModule.resourceIds.push(item.resourceId);
              activeModule.item.push({
                checked: item.checked,
                resourceId: item.resourceId,
                resourceNameShow: item.resourceNameShow,
                showOrder: item.showOrder
              });
              //增加二级展示
              if (item.children && item.children.length > 0) {
                item.children.forEach(n => {
                  activeModule.resourceIds.push(n.resourceId)
                  activeModule.item.push({
                    checked: n.checked,
                    resourceId: n.resourceId,
                    resourceNameShow: n.resourceNameShow,
                    showOrder: n.showOrder
                  });
                })
              }
            });
            localStorage.setItem('ActiveProjectModule', JSON.stringify(activeModule));
            this.$router.push(location);
            this.reload();
            localStorage.removeItem('incomeAuth');
            for (let i in data) {
              if (data[i].resourceId == 186) {
                localStorage.setItem('incomeAuth', JSON.stringify(data[i].children));
              }
            }
          }
          // this.$router.push(location)
          // this.projectoptions.forEach(item=>{
          //   if(item.projectId==this.$route.query.projectId){
          //     this.title = item.projectName;
          //   }
          // })
        });
      },
      toSystem() {
        if (this.platformResources.length > 1) {
          this.$router.push({
            path: '/system'
          });
        } else {
          return false;
        }
      },
      toHome() {
        if (this.platformResources.length > 0) {
          this.$router.push({
            path: '/svolt'
          });
        } else {
          return false;
        }
      },
      //初始化判断是否可以向右滚动
      initgoRightArrow() {
        const currentScrollWidth = this.$refs[`fixedBox`].clientWidth;
        this.signleWidth = this.$refs.centerScroll.children[0].offsetWidth;
        const canNumber = Math.floor(currentScrollWidth / this.signleWidth); //可以放下的个数
        //如果最后一个流程图标已经展示出来，则停止滚动
        if (this.currentClickNumber + canNumber >= this.$refs.centerScroll.children.length) {
          this.noScrollRight = false;
          return;
        }
      },
      //点击上一个
      fnPrev() {
        //如果右点击的次数大于0，才可以左滚
        if (this.currentClickNumber > 0) {
          this.currentClickNumber -= 1;
          this.noScrollRight = true;
          this.fnScrollWidth('reduce');
        } else {
          return false;
        }
      },
      //点击下一个
      fnNext() {
        const currentScrollWidth = this.$refs[`fixedBox`].clientWidth;
        const canNumber = Math.floor(currentScrollWidth / this.signleWidth); //可以放下的个数
        //如果最后一个流程图标已经展示出来，则停止滚动
        if (this.currentClickNumber + canNumber >= this.$refs.centerScroll.children.length) {
          return;
        }
        //说明放不下有滚动条
        if (this.$refs.centerScroll.children.length > canNumber) {
          this.currentClickNumber += 1;
          if (this.currentClickNumber + canNumber >= this.$refs.centerScroll.children.length) {
            this.noScrollRight = false;
          }
          this.fnScrollWidth('add');
        }
      },
      //translate的宽度
      fnScrollWidth(type) {
        let result = 0;
        if (type === 'reduce') {
          result = 118;
        } else if (type === 'add') {
          result = -118;
        } else {
          result = 0;
        }
        this.scrollResultWidth += result;
      }
    },
    created() {
      this.projectId = this.$route.query.projectId;
      let info = JSON.parse(getInfo());
      if (info) {
        this.groupId = info.groupId;
        this.username = info.user.username;
        this.groupInfo = info.groupInfo;
        this.platformResources = info.platformResources;
        document.title = this.groupInfo.groupName;
        this.searchProjects();
      }
      //切换模块
      let authStr = localStorage.getItem('ActiveProjectModule');
      let auth = authStr ? JSON.parse(authStr) : null;
      if (!auth || !auth.resourceIds) {
        this.activeModuleIds = [];
        this.projectMenuDateAuth = [];
        return;
      }
      this.activeModuleIds = auth.resourceIds;
      this.projectMenuDateAuth = [];
      this.projectMenuData.forEach(item => {
        if (item.resourceId == 0) {
          this.projectMenuDateAuth.push(item);
        }
        if (auth.resourceIds.includes(item.resourceId)) {
          this.projectMenuDateAuth.push(item);
        };
      })
      // this.$nextTick(() => {
      //   if (this.$refs.centerScroll.children.length > 5) {
      //     this.isArrow = true;
      //   } else {
      //     this.isArrow = false;
      //     let rightBtn = this.$refs.fixedBox;
      //     rightBtn.style.marginLeft = "20px";
      //   }
      //   setTimeout(() => {
      //     this.initgoRightArrow();
      //   });
      // });
    },
    mounted() {}
  };
</script>

<style>
  .iconx {
    width: 20px;
    height: 20px;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    color: #FFFFFF;
    margin-top: 4px;
  }
</style>
<style lang="scss" scoped>
  .nw-header {
    position: relative;
    overflow-x: hidden;
    width: 100%;
    height: 70px;
    z-index: 10;
    top: 0px;
    text-align: center;
    background: url('/static/images/svolt/nanwang/header-bj-1920.png') no-repeat;
    background-size: 100%;

    .navMenu {
      font-size: 20px;
      line-height: 40px;
      position: absolute;
      left: 10px;
      top: 10px;
      cursor: pointer;
    }

    .el-icon-s-fold:before,
    .el-icon-s-unfold:before {
      color: #4875D9;
    }

    .logo {
      position: absolute;
      left: 40px;
      top: 10px;
      cursor: pointer;

      // img {
      //   height: 44px;
      // }
    }

    .top1 {
      top: 1px;
    }

    .top12 {
      top: 12px;
    }

    .height56 {
      height: 56px;
    }

    .height36 {
      height: 36px;
    }

    .title {
      height: 70px;
      line-height: 60px;
      position: absolute;
      left: 8%;
      font-size: 30px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #0737A2;
      // background-image: -webkit-linear-gradient(bottom, #e6fef9, #90cfff);
      // -webkit-background-clip: text;
    }

    .button-list-left {
      position: absolute;
      display: flex;
      left: 15%;
      top: 12px;

      &:hover {
        cursor: pointer;
      }

      .btnx {
        margin-left: 8px;
      }
    }

    .button-list-right {
      position: absolute;
      display: flex;
      right: 7.5%;
      top: 12px;
      width: 500px;
      height: 40px;

      &:hover {
        cursor: pointer;
      }

      .arrow {
        width: 20px;
        height: 20px;
        color: #5b93e3;
        cursor: pointer;
        margin-top: 8px;
      }

      .fixedBox {
        flex: 1;
        overflow: hidden;
      }

      .btnx {
        float: left;
        margin-left: 8px;
      }
    }

    .wrap {
      display: inline-block;
      margin-top: 8px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      // text-align: center;

      .txt {
        font-size: 20px;
        // font-family: 'Helvetica';
        font-weight: 600;
        color: #ffffff;
        line-height: 48px;
      }

      .el-icon-caret-bottom {
        color: #ffffff;
        font-size: 20px;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .homePage {
      cursor: pointer;
      width: 24px;
      float: right;
      line-height: 55px;
      margin-right: 10px;

      img {
        width: 16px;
      }
    }

    .header-icon {
      cursor: pointer;
      width: 24px;
      float: right;
      line-height: 55px;
      margin-right: 10px;

      .el-badge {
        color: #fff;
        width: 24px;
      }

      .item {
        margin-right: 40px;
      }

      >>>.el-badge__content.is-fixed {
        transform: translateY(50%) translateX(75%) !important;
      }

      img {
        width: 16px;
      }
    }

    .exit {
      // position: absolute;
      width: 24px;
      float: right;
      line-height: 55px;
      margin-right: 10px;

      img {
        width: 16px;
        height: 17px;
      }

      &:hover {
        cursor: pointer;
      }
    }

    .ext-menu {
      width: 24px;
      float: right;
      line-height: 58px;
      margin-right: 10px;
      font-size: 18px;
      color: #2468be;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
<style lang="scss">
  .el-popover.w-project-open-menu {
    background: rgba(0, 98, 202, 0.9) !important;
    border: 1px solid #85d5ff;
    color: #fff;
    width: 120px;
    // height: 70px;
    line-height: 25px;
    padding-left: 10px !important;
    text-align: left;

    .popper__arrow {
      display: none;
    }
  }

  .el-popover.el-popper.w-project-open-menu {
    border-color: #85d5ff;
    // margin-top: -10px;
  }

  .w-project-menu-list li:hover,
  .w-project-menu-list li:active {
    color: #19cae4;
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/header.vue